<template>
    <div>
         <hr style="margin: 20px 0px 20px 0px;border-style: ridge;">
        <h3 class="hidden-sm-and-down alignleftTitle">Custom Made Blinds 
        
        </h3>
        <div  class="hidden-md-and-up" @click="addNewBlind">
        <el-tag type="success" style="font-size:10px"><i class="el-icon-plus"></i></el-tag>
        </div>
        <el-row :gutter="20" class="hidden-sm-and-down alignLeft">
            <el-col :lg="1" :md="1" :offset="2" class="alignCenter">No.</el-col>
            <el-col :lg="3" :md="3">Reference</el-col>
            <el-col :lg="3" :md="3">
                Blind Type
                 <el-popover placement="top-start" width="800" trigger="hover">
                 
                    
                    <table cellpadding="8px">
                        <th style="width:30px">Name</th>
                        <th style="width:20px">Price</th>
                        <th style="width:50px">What is It</th>
                        <th style="width:50px">Great for</th>
                        <th style="width:50px">Sample Picture</th>                        
                        <tr>
                            <td>Roller Blinds</td>
                            <td>$49/m2</td>
                            <td>Fabric wraps neatly around a tube at the top of the window.</td>
                            <td>All rooms.</td>
                            <td><a href="https://api.ifurniture.co.nz/image/RollerBlinds.png" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/RollerBlinds.png"></a></td>                                                      
                        </tr>
                        <tr>
                            <td>Venetian Blinds</td>
                            <td>$79/m2</td>
                            <td>Metal horizontal slats which tilt to control light and privacy.</td>
                            <td>All rooms.</td>
                             <td><a href="https://api.ifurniture.co.nz/image/VenetianBlinds.png" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/VenetianBlinds.png"></a></td>                                                      
                        </tr>
                        <tr>
                            <td>Wooden/PVC Blinds</td>
                            <td>$119/m2</td>
                            <td>Wooden/PVC horizontal slats which tilt to control light and privacy.</td>
                            <td>Bedrooms, living rooms and dining rooms.</td>
                            <td><a href="https://api.ifurniture.co.nz/image/WoodenPVCBlinds.png" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/WoodenPVCBlinds.png"></a></td> 
                        </tr>
                       <tr>
                            <td>Zebra Blinds</td>
                            <td>$89/m2</td>
                            <td>Our light filtering zebra shades offer both sheer fabric and light 
                                filtering fabric in the same shade , the unique fabric offers a zebra 
                                like pattern with alternating stripes of light filtering and sheer shades</td>
                            <td>Living and Dining room.</td>
                             <td><a href="https://api.ifurniture.co.nz/image/ZebraBlinds.png" target="_blank"> <img class="hintPicture" src="https://api.ifurniture.co.nz/image/ZebraBlinds.png"></a></td> 
                        </tr>
                    </table>
                  <div class="el-icon-info" slot="reference" style="color:green"></div>
                 </el-popover>
            </el-col>
             <el-col :lg="2" :md="2">Width(cm)
               <el-popover placement="top-start" title="Please use inner width as the blinds are inside mounted." 
               width="310" trigger="hover">
                  
                    <img src="../assets/blind-width.png" alt="">
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
             </el-col>
            <el-col :lg="2" :md="2">Drop(cm)</el-col>
          
            <el-col :lg="2" :md="2">Price</el-col>
            <el-col :lg="1" :md="1">Saved</el-col>
            <el-col :lg="2" :md="2">Operation</el-col>
        </el-row>
        
        <el-row v-for="(customerMadeBlind,index) in customerMadeBlinds" :key="index" class="rowpadding hidden-sm-and-down">
            <el-form :rules="rulesNumber" :model="customerMadeBlind">
            <el-col :lg="1" :md="1" :offset="2" class="colpadding">{{index+1}}</el-col>
            <el-col :lg="3" :md="3" class="colpadding">
                <el-input v-model="customerMadeBlind.Window"  @input="inputChange(index)"></el-input>
            </el-col>
            <el-col :lg="3" :md="2" class="colpadding">
                 <el-select v-model="customerMadeBlind.Type" placeholder="Type of Blind" value-key="cusBlindType" @change="addCurtain(index)">
                 <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
            </el-col>
             <el-col :lg="2" :md="2" class="colpadding">
                
                  <el-form-item  prop="Width">
                 <el-input v-model="customerMadeBlind.Width"    @input="inputChange(index)"></el-input>
                  </el-form-item>
            </el-col>
            <el-col :lg="2" :md="2" class="colpadding">
                <el-form-item  prop="Drop">
                <el-input v-model="customerMadeBlind.Drop"    @input="inputChange(index)"></el-input>
                </el-form-item>
            </el-col>
           
           
            <el-col :lg="2" :md="2" class="colpadding alignLeft">
            
              <div class="info priceStyle">${{customerMadeBlind.Price}}</div>
            </el-col>
             <el-col :lg="1" :md="1" class="colpadding">
                <i :class="customerMadeBlind.Saved"></i>
            </el-col>
            <el-col :lg="2" :md="2" class="colpadding">
              <el-button type="danger" @click="removeBlind(customerMadeBlind)">Delete</el-button>
            </el-col>
             </el-form>
        </el-row>
        <el-row class="rowpadding hidden-sm-and-down alignLeft" style="margin-left:10%">
             <el-button type="success" @click="addNewBlind">Add a Custom Made Blind</el-button>
        </el-row>
       
        <div class="hidden-md-and-up">
        <el-card class="box-card" v-for="(customerMadeBlind,index) in customerMadeBlinds" :key="index" >
            <el-form :rules="rulesNumber" :model="customerMadeBlind">
         <div slot="header" class="clearfix">
          <span>No.{{index+1}}</span>
          <el-button style="float: right; padding: 3px 0" type="success" @click="addNewBlind">Add</el-button>
         </div>
         <div style="text-align:left">
             <el-row class="rowpadding">
             <el-col :sm="6" :xs="6" style="word-wrap:break-word; ">Reference</el-col>
              <el-col :sm="16" :xs="16"><el-input v-model="customerMadeBlind.Window"  @input="inputChange(index)"></el-input></el-col>
            </el-row>
            <el-row class="rowpadding">
                <el-col :sm="6" :xs="6">
                    Type
               <el-popover placement="top-start" width="310" trigger="hover">
                 <el-collapse v-model="activeName" accordion style="width:300px;padding:10px;margin:5px">
                   <el-collapse-item title="Roller blinds" name="1">
                      <p>What is it?: Fabric wraps neatly around a tube at the top of the window.</p>
                      <p>Great for: All rooms.</p>
                      <p>Cleaning: Wipe clean with a dry cloth, or wet cloth for water-resistant options.</p>
                      <p>How it works: Sidewinder with plastic chain to lift and lower.</p>
                    
                    </el-collapse-item>
                   <el-collapse-item title="Venetian blinds" name="2">
                   <p>What is it?: Metal horizontal slats which tilt to control light and privacy.</p>
                   <p>Great for: All rooms.</p>
                   <p>Cleaning: Wipe clean with a dry cloth.</p>
                   <p>How it works: Tilt rod to adjust louvres for light and privacy. Cord to lift and lower.</p>
              </el-collapse-item>
               <el-collapse-item title="Wooden/PVC blinds" name="3">
                <p>What is it?: Wooden/PVC horizontal slats which tilt to control light and privacy.</p>
                <p>Great for: Bedrooms, living rooms and dining rooms.</p>
                <p>Cleaning: Wipe clean with a dry cloth.</p>
                <p>How it works: Cords to lift, lower and tilt slats.</p>
               </el-collapse-item>
               <el-collapse-item title="Zebra Blinds" name="4">
                <p>What is it?: Our light filtering zebra shades offer both 
                    sheer fabric and light filtering fabric in the same shade , 
                    the unique fabric offers a zebra like pattern with alternating stripes of light filtering and sheer shades</p>
                    <p>Great for: Living and  Dining room.</p>
                    <p>Cleaning: Wipe clean with a dry cloth, or wet cloth for water-resistant options.</p>
                    <p>How it works: Tilt rod to adjust louvres for 
                        light and privacy. Cord to lift and lower. these roller style shades 
                        can be either raise or you can align the fabric vanes .Aligning the front and back 
                        sections of the fabric allow the shades to be either privacy or sheer shades.</p>
                 </el-collapse-item>
              </el-collapse>
                    
               <div class="el-icon-info" slot="reference" style="color:green"></div>
                 </el-popover>
                </el-col>
                <el-col :sm="16" :xs="16">
                     <el-select v-model="customerMadeBlind.Type" placeholder="Type" value-key="cusBlindTypeM" @change="addCurtain(index)">
                 <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                 </el-option>
                 </el-select>
                </el-col>
            </el-row>
            <el-row class="rowpadding">
                <el-col :sm="6" :xs="6">Width(cm)
                   <el-popover placement="top-start" title="Please use inner width as the blinds are inside mounted." 
               width="310" trigger="click">
                  <img src="../assets/blind-width.png" alt="" style="width:300px;height:400px">
               <div class="el-icon-info" slot="reference" style="color:green"></div>
               </el-popover>
                </el-col>
                <el-col :sm="16" :xs="16"> 
                    <el-form-item  prop="Width" style="margin:0">
                    <el-input v-model="customerMadeBlind.Width"  @input="inputChange(index)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="rowpadding">
                <el-col :sm="6" :xs="6">Drop(cm)</el-col>
                <el-col :sm="6" :xs="16"> 
                     <el-form-item  prop="Drop">
                    <el-input v-model="customerMadeBlind.Drop"  @input="inputChange(index)"></el-input>
                     </el-form-item>
                </el-col>
            </el-row>
        </div>
         <hr>
         <div>Price:
           
            <span class="info priceStyle">${{customerMadeBlind.Price}}</span>
             Saved:
             <i :class="customerMadeBlind.Saved"></i>
             <el-button style="float: right; padding: 3px 0" type="danger" @click="removeBlind(customerMadeBlind)">Delete</el-button>
         </div>
        </el-form>
        </el-card>
       </div> 
      
    </div>
</template>
<script>
import { addCurtain } from "@/api/AddCurtain";
import { deleteCurtain } from "@/api/DeleteCurtain";
import _ from "lodash";

export default {
  name: "CusMadeBlinds",
  props: ["cusMadeBlinds", "options"],
  watch: {
    options: {
      deep: true,
      handler(nv, ov) {
        this.allOptions = nv;
      
        this.getOprtions();
      }
    }
  },

  data() {
    var checkNum = (rule, value, callback) => {
      if (isNaN(value)) {
        return callback(new Error("valid from 1 to 1000"));
      } else if (value < 1 || value > 1000) {
        return callback(new Error("valid from 1 to 1000"));
      } else {
        callback();
      }
    };
    return {
      curtainsOptions: this.options,
      activeName: "1",
      customerMadeBlinds: this.cusMadeBlinds,
      allOptions: [],
      typeOptions: [],
      fabricOptions: [],
      rulesNumber: {
        Width: [{ validator: checkNum, trigger: ["blur", "change"] }],
        Drop: [{ validator: checkNum, trigger: ["blur", "change"] }]
      }
    };
  },

  methods: {
    addNewBlind() {
      const newBlind = {
        CurtainId: "",
        Window: "",
        Type: "",
        Drop: null,
        Width: null,
        //  Fabric:'',
        Price: 0,
        Saved: "el-icon-close"
      };
      this.customerMadeBlinds.push(newBlind);
      //  window.scrollTo(0,document.body.scrollHeight);
    },
    removeBlind(item) {
      var index = this.customerMadeBlinds.indexOf(item);
      if (index !== -1) {
        if (this.customerMadeBlinds[index].CurtainId !== "") {
          //  console.log(this.customerMadeBlinds[index].CurtainId);
          deleteCurtain(this.customerMadeBlinds[index].CurtainId)
            .then(res => {
              if (res.data.Success) {
                this.$store.commit("changeCurtain");
              }
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        }
        this.customerMadeBlinds.splice(index, 1);
      }
    },
    getOprtions() {
      this.allOptions.forEach(item => {
        if (item.modelName === "Custom Made Blinds") {
          this.typeOptions = item.Types;
          this.fabricOptions = item.Fabrics;
        }
      });
    },
    addCurtain(index) {
      if (
        this.customerMadeBlinds[index].Type !== "" &&
        !isNaN(this.customerMadeBlinds[index].Drop) &&
        this.customerMadeBlinds[index].Drop > 0 &&
        this.customerMadeBlinds[index].Drop <= 1000 &&
        !isNaN(this.customerMadeBlinds[index].Width) &&
        this.customerMadeBlinds[index].Width > 0 &&
        this.customerMadeBlinds[index].Width <= 1000
      ) {
        const CurtainQuoationId = localStorage.getItem("curtain_quoationId");
        const CurtainCustomerId = localStorage.getItem("curtain_customerId");
        const newCurtain = {};
        newCurtain.CurtainId = this.customerMadeBlinds[index].CurtainId;
        newCurtain.RoomName = this.customerMadeBlinds[index].Window;
        newCurtain.CurtainDrop = this.customerMadeBlinds[index].Drop;
        newCurtain.CurtainWidth = this.customerMadeBlinds[index].Width;
        newCurtain.ModelName = "Custom Made Blinds";

        newCurtain.Type = this.customerMadeBlinds[index].Type;
        newCurtain.Price = this.customerMadeBlinds[index].Price;
        this.$nextTick(() => {
          addCurtain(CurtainQuoationId, CurtainCustomerId, newCurtain)
            .then(res => {
              this.customerMadeBlinds[index].Price = res.data.CPrice.toFixed(2);
              this.customerMadeBlinds[index].CurtainId = res.data.CurtainId;
              //   console.log( this.customerMadeBlinds[index].CurtainId);
              this.customerMadeBlinds[index].Saved = "el-icon-check dataSaved";
              this.$store.commit("changeCurtain");
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        });
      } else {
        this.customerMadeBlinds[index].Saved = "el-icon-close";
        if (this.customerMadeBlinds[index].CurtainId !== "") {
          deleteCurtain(this.customerMadeBlinds[index].CurtainId)
            .then(res => {
              if (res.data.Success) {
                this.customerMadeBlinds[index].CurtainId = "";
                this.customerMadeBlinds[index].Price = 0;
                this.$store.commit("changeCurtain");
              }
            })
            .catch(err => {
              this.$message.error("something wrong when get the data:" + err);
            });
        }
      }
    },
    inputChange: _.debounce(function(index) {
      this.addCurtain(index);
    }, 500)
  }
};
</script>
<style>
.box-card {
  margin: 10px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.rowpadding {
  padding: 5px;
}
.colpadding {
  padding: 3px;
}
.dataSaved {
  background-color: green;
  color: white;
  font-weight: 400;
}
.alignleftTitle {
  text-align: left;
  margin-left: 10%;
}
.alignLeft {
  text-align: left;
}
.alignCenter {
  text-align: center;
}
.priceStyle {
  margin-top: 10px;
  font-weight: bold;
  color: #0066cc;
}

.hintPicture {
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/CusMadeBlinds.vue